export const EligibleStates = ['CA'];
export const NotEligibleTitle = 'Sorry, your area is currently not eligible.';
export const NotEligibleBody = `Your state is not yet eligible for early access.`;
export const NoStateTitle = `We're having an issue determining your location.`;
export const NoStateBody = `Not to worry – this problem's on our end.`;
export const NoStateBody2 = `Try back again soon, or give us a call at (844) 290-0581.`;